export const getInitials = function (string) {
 return string?.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase()
};

